export const ERECOGNITION = `ERECOGNITION`;

/* LAYOUT */
export const GET_TERRITORIES_LIST = `${ERECOGNITION}/GET_TERRITORIES_LIST`;
export const SET_TERRITORIES_LIST = `${ERECOGNITION}/SET_TERRITORIES_LIST`;
